import React, { useState } from 'react';
import {
  Avatar,
  Button,
  Popover,
  Typography,
  MenuItem,
  Divider,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import LogoutIcon from '@mui/icons-material/Logout';

import { useTranslation } from '../i18n';

interface UserMenuProps {
  username: string;
  onLogout: () => void;
}

const UserMenu: React.FC<UserMenuProps> = ({ username, onLogout }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Button
        onClick={handleOpen}
        startIcon={
          <Avatar
            src={`http://ui-avatars.com/api/?name=${username}&background=fff&color=000`}
            alt={username}
            sx={{ width: 32, height: 32 }}
          />
        }
        endIcon={<ArrowDropDownIcon />}
        sx={{
          textTransform: 'none',
          color: 'white',
          padding: '6px 12px',
        }}
      >
        {username}
      </Button>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        slotProps={{
          paper: {
            sx: { p: 1 },
          },
        }}
      >
        <Typography variant="subtitle2" sx={{ px: 1.5, py: 1 }}>
          {t('common.hello', { name: username })}
        </Typography>
        <Divider />
        <MenuItem
          onClick={() => {
            handleClose();
            onLogout();
          }}
          sx={{
            color: 'error.main',
          }}
        >
          <LogoutIcon sx={{ mr: 1 }} />
          {t('common.logout')}
        </MenuItem>
      </Popover>
    </>
  );
};

export default UserMenu;
